import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { AprovarCancelamentoBm, SolicitarCancelamentoBoletimMedicao } from '@app/api/boletimMedicao';
import { Button, Icon } from '@digital/ui';
import ListMensagem from './ListMensagem';
import TextArea from 'antd/lib/input/TextArea';
import { Visibility } from '@app/components';

export interface PropsModalComentario {
  id: string;
  onUpdatePage: () => any;
  step: number;
  justificativaCancelamento?: string;
}

const ModalJustificativaCancelamentoMedicao = (props: PropsModalComentario) => {
  const { id, onUpdatePage, step, justificativaCancelamento } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const textAreaId = `textAreaId${id}`;
  const [justificativa, setJustificativa] = useState('');

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  useEffect(()=>{
    if(justificativa == '' && justificativaCancelamento){
      setJustificativa(justificativaCancelamento);
    }
  },[justificativaCancelamento])
  
  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const Salvar = (e: any) => {
    if(step === 1){
      SolicitarCancelamentoBoletimMedicao(id, { medicaoId: id, justificativa: justificativa }).then(data => {
        if (data) {
          limparCampo();
          if (data.valid) {
            onUpdatePage();
          }
        }
      });
    }else{
      AprovarCancelamentoBm(id, { medicaoId: id, justificativaCancelamentoMedicao: justificativa }).then(data => {
        if (data) {
          limparCampo();
          if (data.valid) {
            onUpdatePage();
          }
        }
      });
    }
    
  };

  return (
    <>
      <Visibility
        permissions={['MEDICAO_QUANTITATIVA_APROVAR_CANCELAMENTO']}
      >
        <Button
          type="link"
          icon="files-delete_file"
          onClick={() => {
            showModal();
          }}>
          CANCELAR BM
        </Button>
      </Visibility>

      <Modal
        title={step === 1 ? "Solicitar Cancelamento Medição" : "Aprovar Cancelamento Medição"}
        className="chat-modal"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submit" type="primary" onClick={e => Salvar(e)}>
            Enviar
          </Button>,
          <Button key="cancel" type="danger" onClick={() => handleCancel()}>
            Fechar
          </Button>,
        ]}>
        <TextArea
          name="justificativa"
          id="justificativa"
          value={justificativa}
          onChange={value => {
            setJustificativa(value.currentTarget.value);
          }}
          placeholder="informe a justificativa"
          rows={3}
          required
        />
      </Modal>
    </>
  );
};

export default ModalJustificativaCancelamentoMedicao;
